import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function FilterAltIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 25 25" htmlColor={Color.Headings} {...props}>
      <path d="M11.835 20.225a.86.86 0 0 1-.63-.254.86.86 0 0 1-.255-.63v-5.789L5.352 6.441q-.288-.385-.083-.8t.691-.416h12.98q.487 0 .692.416.205.415-.084.8l-5.598 7.111v5.788a.86.86 0 0 1-.254.631.86.86 0 0 1-.63.254zm.615-7.2 4.95-6.3H7.5z" />
    </MuiSvgIcon>
  );
}
export default FilterAltIcon;
